import PropTypes from 'prop-types';
import FJPhotoSettingBox from '../view/FJPhotoSettingBox';
import { useSelector } from 'react-redux';
import FJConstant from '../../../../constants/FJConstant';
import useLocalStore from '../../../../hooks/useLocalStore';

const FJPhotoSettingBoxContainer = props => {
    useLocalStore();
    const { isShow } = props;

    const brushEditStatus = useSelector(state => state.brushEditCommon.brushEditStatus);
    const editImageLoadStatus = useSelector(state => state.brushEditCommon.editImageLoadStatus);

    const isDisabled = brushEditStatus !== FJConstant.DEFAULT || editImageLoadStatus !== FJConstant.SUCCESS;

    return <FJPhotoSettingBox isShow={isShow} disabled={isDisabled} />;
};

FJPhotoSettingBoxContainer.propTypes = {
    isShow: PropTypes.bool,
};

export default FJPhotoSettingBoxContainer;
